import { render, staticRenderFns } from "./d_HealthIntro.vue?vue&type=template&id=739f49ce&scoped=true&"
import script from "./d_HealthIntro.vue?vue&type=script&lang=js&"
export * from "./d_HealthIntro.vue?vue&type=script&lang=js&"
import style0 from "./d_HealthIntro.vue?vue&type=style&index=0&id=739f49ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739f49ce",
  null
  
)

export default component.exports